"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _withProps = _interopRequireDefault(require("recompose/withProps"));

var _react = _interopRequireWildcard(require("react"));

var _IconDanger = _interopRequireDefault(require("../Icon/IconDanger"));

var _IconSuccess = _interopRequireDefault(require("../Icon/IconSuccess"));

var _IconWarning = _interopRequireDefault(require("../Icon/IconWarning"));

var _styles = require("../styles");

var _IconArrowDropdownUp = _interopRequireDefault(require("../Icon/IconArrowDropdownUp"));

var _IconArrowDropdownDown = _interopRequireDefault(require("../Icon/IconArrowDropdownDown"));

var _styled2 = require("./styled");

var _constants = require("./constants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var variantIcons = {
  danger: (0, _core.jsx)(_IconDanger.default, null),
  success: (0, _core.jsx)(_IconSuccess.default, null),
  warning: (0, _core.jsx)(_IconWarning.default, null)
};
var iconMarginMap = {
  small: 4,
  medium: 8,
  large: 8,
  jumbo: 14
};

var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};

var SelectTrigger =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SelectTrigger, _Component);

  function SelectTrigger() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SelectTrigger.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        isOpen = _this$props.isOpen,
        item = _this$props.item,
        name = _this$props.name,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        triggerRef = _this$props.triggerRef,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? _constants.SIZE.large : _this$props$size,
        variant = _this$props.variant,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["disabled", "isOpen", "item", "name", "placeholder", "readOnly", "triggerRef", "size", "variant"]);

    var ArrowIcon = isOpen ? _IconArrowDropdownUp.default : _IconArrowDropdownDown.default;
    var Arrow = (0, _withProps.default)({
      size: size === _constants.SIZE.small || size === _constants.SIZE.medium ? _constants.SIZE.medium : (0, _styles.pxToEm)(24)
    })((
    /*#__PURE__*/
    0, _styledBase.default)(ArrowIcon, {
      target: "e7c9dyg0"
    })({
      margin: (0, _styles.pxToEm)(iconMarginMap[size])
    }));
    var controlProps = {
      hasPlaceholder: !item,
      variant: item && item.variant
    };
    var inputProps = {
      name: name,
      onClick: stopPropagation,
      // Stop extra click Event in Edge from closing Select
      type: 'hidden',
      value: item ? item.value : ''
    };

    var rootProps = _objectSpread({
      afterItems: [(0, _core.jsx)(Arrow, {
        key: "arrow"
      }), (0, _core.jsx)("input", _extends({}, inputProps, {
        key: "input"
      }))],
      control: _styled2.Trigger,
      controlProps: controlProps,
      disabled: disabled,
      fauxControlRef: triggerRef,
      readOnly: readOnly,
      selectedItemVariant: item && item.variant,
      size: size,
      variant: variant
    }, restProps);

    if (item) {
      var iconEnd = item.iconEnd,
          iconStart = item.iconStart,
          _variant = item.variant;
      rootProps = _objectSpread({}, rootProps, {
        iconEnd: iconEnd,
        iconStart: _variant ? variantIcons[_variant] : iconStart,
        item: item,
        variant: this.props.variant
      });
    }

    return (0, _core.jsx)(_styled2.SelectTriggerRoot, rootProps, (0, _core.jsx)(_styled2.TriggerContent, null, item ? item.text : placeholder));
  };

  return SelectTrigger;
}(_react.Component);

exports.default = SelectTrigger;

_defineProperty(SelectTrigger, "displayName", 'SelectTrigger');